import { Button, Grid, Typography } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { PasswordIput } from "../login/components/passwordIput";
import Swal from "sweetalert2";
import { resetPassword } from "services/authServices/authServices";
import { useState } from "react";

type Inputs = {
  password: string;
  password_confirm: string;
};

export const ResetPasswordForm = ({ token }: { token: string | null }) => {
  const methods = useForm<Inputs>();
  const [state, setState] = useState("default");

  const onSubmit = async (data: any) => {
    try {//eslint-disable-next-line
      if (data.password != data.password_confirm) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Las contraseñas no coinciden",
        });

        return;
      }
      setState("loading");

      let response = await resetPassword({
        newPassword: data.password,
        newPassword_confirmation: data.password_confirm,
        token: token,
        confirmButtonText: "Aceptar",
      });

      setState("default");
      //eslint-disable-next-line
      if (response.status == 200) {
        Swal.fire({
          icon: "success",
          title: "Contraseña restaurada",
          text: "Se ha restaurado su contraseña",
          confirmButtonText: "Aceptar",
        }).then(() => window.location.replace("/login"));
        return;
      }
    } catch (error: any) {
      setState("default");

      if (error.response.status >= 400 && error.response.status < 500) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response.data.data,
          confirmButtonText: "Aceptar",
        });
      } else if (error.response.status >= 500) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Ha ocurrido un error interno, por favor inténtalo más tarde.",
          confirmButtonText: "Aceptar",
        });
      }
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle1">
              Con este procedimiento, modificará tanto su contraseña del
              Tribunal Electrónico como del correo institucional (la contraseña de su Firma Electrónica no se vera afectada).
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <PasswordIput name="password" label="Nueva contraseña" />
          </Grid>
          <Grid item xs={12}>
            <PasswordIput
              name="password_confirm"
              label="Confirmar contraseña"
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="error"
              className="my-3 w-full"
              type="submit"//eslint-disable-next-line
              disabled={state == "loading"}
            >
              Restaurar contraseña
            </Button>
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
};
